import React, { useEffect } from "react";
import classNames from "classnames";
import ModalBooking from "../Modal-booking";

const Calendar = ({ refreshTime, selectedTimes, currentUser, onBooked }) => {
  const [selectedDate, setSelectedDate] = React.useState(null);

  useEffect(() => {
    setSelectedDate(null);
  }, [selectedTimes]);

  const userTimes = selectedTimes[currentUser];

  const parseDateKey = (dateKey) => {
    const [month, day, year] = dateKey.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const sortedDates = userTimes
    ? Object.keys(userTimes).sort(
        (a, b) => parseDateKey(a).getTime() - parseDateKey(b).getTime()
      )
    : [];

  const availableDays = sortedDates.filter(
    (date) => selectedTimes[currentUser][date]?.length
  );

  const formatDate = (date) =>
    parseDateKey(date).toLocaleDateString("uk-UA", {
      weekday: "short",
      day: "numeric",
      month: "long",
    });

  return (
    <section className="calendar">
      <div className="section-heading calendar-heading">
        <div>
          <div className="section-kicker">Графік</div>
          <h2>Вільні дати та години</h2>
        </div>
        <div className="section-note">
          {availableDays.length
            ? `${availableDays.length} дн. з доступними слотами`
            : "Нові слоти з’являться найближчим часом"}
        </div>
      </div>
      <div className="calendar-contaner">
        {selectedTimes[currentUser] &&
          sortedDates?.map((itemDate) => {
            if (!selectedTimes[currentUser][itemDate].length) {
              return null;
            }
            return (
              <div
                key={itemDate}
                className={classNames("item", {
                  selected: selectedDate === itemDate,
                })}
                onClick={() => setSelectedDate(itemDate)}
              >
                <div className="calendar-date">{formatDate(itemDate)}</div>
                <div className="calendar-date-raw">{itemDate}</div>
                <div className="calendar-slots-count">
                  {selectedTimes[currentUser][itemDate]?.length} вільних слотів
                </div>
                <div className="calendar-slot-list">
                  {selectedTimes[currentUser][itemDate]?.map((itemTime) => (
                    <span key={itemTime} className="calendar-slot-chip">
                      {itemTime}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
      </div>
      {selectedTimes[currentUser] &&
      Object.keys(selectedTimes[currentUser]).length ? (
        <ModalBooking
          selectedDate={selectedDate}
          slots={selectedTimes[currentUser]?.[selectedDate] || []}
          trainer={currentUser}
          refreshTime={refreshTime}
          onBooked={onBooked}
        />
      ) : null}
    </section>
  );
};

export default Calendar;
